// Copyright (c) 2022 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { postExpectationsClient } from "../../../app/rpc/client"
import * as Slice from "../slices/stats"
import {
  ListMemberExpectationsRequest,
  ListMemberExpectationsResponse,
} from "../../../generated/legebill/site/postexpectation/v4/post_expectation_pb"
import { showSnackBar } from "../../snackbar/actions"

type ListMemberExpectationsRpc = (request: ListMemberExpectationsRequest) => Observable<ListMemberExpectationsResponse>

export const refreshMemberExpectations = (listMemberExpectationsRpc: ListMemberExpectationsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.refreshMemberExpectations.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(listMemberExpectationsRpc),
          map(response => ({
            siteId: action.payload.getSiteId(),
            memberExpectations: response.toObject().memberExpectationsList,
          })),
          map(Slice.updateSiteMemberExpectations),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_refresh_member_expectations_failed",
              message: "Failed to update time posting goal. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const listMemberExpectationsRpc = (request: ListMemberExpectationsRequest): Observable<ListMemberExpectationsResponse> =>
  grpc(() => postExpectationsClient.listMemberExpectations(request, null))

export default refreshMemberExpectations(listMemberExpectationsRpc)
